export default "__VITE_ASSET__b079bb29__"